<template>
  <TextInput
    :id="$attrs.id || 'mobile_phone'"
    v-bind="$attrs"
    :class="$attrs.class || 'field required'"
    :name="$attrs.name || 'mobile_phone'"
    :label="$attrs.label || 'Número do celular'"
    :placeholder="$attrs.placeholder || '(00) 9 0000-0000'"
    :helper-message="$attrs.helperMessage || 'Informe o número com DDD.'"
    :helper-size="11"
    mask="(##) # ####-####"
    inputmode="numeric"
    validations="required|tel|validDDD|ninenumber"
    @input="$emit('input', $event)"
  />
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'MobilePhoneInput',
  components: {
    TextInput,
  },
  inheritAttrs: false,
  emits: ['input'],
}
</script>
<style lang="scss"></style>
